<template>
  <div>
    <v-toolbar
      app
      :clipped-left="true"
      dark
      flat
      dense
      color="primary"
      class="main-nav-bar"
      style="color: rgba(255,255,255,.85); background-color: rgb(0, 94, 166) !important;"
    >
      <v-toolbar-side-icon @click.stop=""/>

      <v-toolbar-title v-text="appTitle"/>
      <v-spacer/>

      <v-toolbar-items>
        <v-btn
          flat
          dark
          @click="$router.push('/login')"
        >
          登录
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <v-container fluid grid-list-xl>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm8 md7 lg5 xl4>
            <v-card>
              <v-toolbar flat dark color="light-blue lighten-2">
                <v-icon>person</v-icon>
                <v-toolbar-title style="font-size: 16px;">注册新用户</v-toolbar-title>
              </v-toolbar>
              <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>
              <v-alert
                type="info"
                :value="showMessage"
                style="margin: 0;border-color: transparent !important;"
              >
                {{message}}
              </v-alert>
              <v-card-text>
                <v-form v-model="registerForm" ref="registerForm" lazy-validation>
                  <v-container fluid grid>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field
                          label="统一社会信用代码"
                          v-model="item.username"
                          :rules="rules.username"
                        />
                      </v-flex>

                      <v-flex xs6>
                        <v-text-field
                          label="电子邮箱"
                          v-model="item.email"
                          :rules="rules.email"
                        />
                      </v-flex>

                      <v-flex xs6>
                        <v-text-field
                          label="密码"
                          type="password"
                          v-model="item.password"
                          :rules="rules.password"
                        />
                      </v-flex>

                      <v-flex xs6>
                        <v-text-field
                          label="确认密码"
                          type="password"
                          v-model="item.passwordRepeat"
                          :rules="rules.passwordRepeat"
                        />
                      </v-flex>

                      <v-flex xs12>
                        <v-text-field
                          label="企业名称"
                          v-model="item.enterpriseName"
                          :rules="rules.enterpriseName"
                        />
                      </v-flex>

                      <v-flex xs6>
                        <v-text-field
                          label="联系人"
                          v-model="item.contact"
                          :rules="rules.contact"
                        />
                      </v-flex>

                      <v-flex xs6>
                        <v-text-field
                          label="联系电话"
                          v-model="item.telephone"
                          :rules="rules.telephone"
                        />
                      </v-flex>

                      <v-flex xs6>
                        <v-select
                          label="所属州/市"
                          item-text="name"
                          item-value="dbid"
                          v-model="item.city"
                          :rules="rules.required"
                          :items="cityItems"
                          :loading="cityLoading"
                          @change="onCityChange"
                        />
                      </v-flex>

                      <v-flex xs6>
                        <v-select
                          label="是否属于园区"
                          v-model="item.inPark"
                          :items="[{text:'否', value:'F'}, {text:'是', value:'T'}]"
                          :rules="rules.required"
                          @change="()=> {item.park='';item.county=''}"
                        />
                      </v-flex>

                      <v-flex xs6>
                        <v-select
                          label="所属县/区"
                          item-text="name"
                          item-value="dbid"
                          :disabled="item.inPark !== 'F' "
                          v-model="item.county"
                          :items="countyItems"
                          :loading="countyLoading"
                          :rules="rules.county"
                        />
                      </v-flex>

                      <v-flex xs6>
                        <v-select
                          label="工业园区"
                          item-text="name"
                          item-value="dbid"
                          :disabled="item.inPark !== 'T' "
                          v-model="item.park"
                          :items="parkItems"
                          :loading="parkLoading"
                          :rules="rules.park"
                          @change="onParkChange"
                        />
                      </v-flex>

                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :disabled="loading" @click="onRegister">注册</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        loading: false,
        registerURI: "/api/register",
        districtURI: "/api/syst/department",

        registerForm: false,
        item: {
          username: '',
          password: '',
          passwordRepeat: '',

          enterpriseName: '',
          contact: '',
          telephone: '',

          city: '',
          county: '',

          inPark: '',
          park: ''
        },

        cityItems: [],
        cityLoading: false,

        countyLoading: false,
        countyItems: [],

        parkLoading: false,
        parkItems: [],


        message: '',

        rules: {
          username: [
            v => !!v || '必填项。',
            v => (v && /^[^_IOZSVa-z\W]{2}\d{6}([^_IOZSVa-z\W]{10}|[^_IOZSVa-z\W]{12})$/g.test(v)) || '统一社会信用代码格式不正确。'
          ],
          email: [
            v => !!v || '必填项。',
            v => /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/ig.test(v) || "邮箱地址格式不正确。",
            v => (v && v.length < 50) || "长度不能超过 50 个字符。"
          ],
          password: [
            v => !!v || '必填项。',
            v => (v && /^[^\s]+$/.test(v)) || '密码不能保含空格.',
            v => (v && /^(?![0-9]+$)(?![^0-9]+$)(?![a-zA-Z]+$)(?![^a-zA-Z]+$)(?![a-zA-Z0-9]+$)[a-zA-Z0-9\S]{8,30}$/.test(v)) || '密码强度不满足要求,密码要包含数字、字母和特殊字符，长度要求8位以上'
          ],

          passwordRepeat: [
            v => !!v || '必填项。',
            v => (v && this.item.password === v) || "两次输入的密码不一致。"
          ],
          enterpriseName: [
            v => !!v || '必填项。',
            v => (v && v.length < 50) || "长度不能超过 50 个字符。"
          ],

          contact: [
            v => !!v || '必填项。',
            v => (v && v.length < 20) || "长度不能超过 50 个字符。"
          ],

          telephone: [
            v => !!v || '必填项。',
            v => (v && v.length < 20) || "长度不能超过 50 个字符。",
            v => (v && /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/ig.test(v)) || '电话号码格式不正确。'
          ],

          park: [
            v => (this.item.inPark !== 'T' || !!v) || '必填项。',
          ],

          county: [
            v => (this.item.inPark !== 'F' || !!v) || '必填项。',
          ],

          required: [
            v => !!v || '必填项。'
          ]
        }
      }
    },
    created() {
      this.getCities();
    },
    computed: {
      appTitle() {
        return document.title;
      },
      showMessage() {
        return this.message && this.message.length > 0;
      }
    },
    methods: {
      getCities() {
        const vm = this;
        vm.cityLoading = true;
        this.axios.get(
          this.districtURI,
          {
            params: {
              // 州市
              parentId: 'DbS_Ug90wAA',
              // 工信部门
              type: 'G_city',
              // 不是省工信的处室
              inheritParent: 'F',
              // 未禁用
              disabled: 'F'
            }
          }
        ).then(
          rsp => {
            vm.cityItems = rsp.data.items;
            vm.cityLoading = false;
          })
      },

      onCityChange(cityDbid) {
        const vm = this;

        vm.countyLoading = true;
        vm.parkLoading = true;

        const cityCode = this.cityItems.find(c => c.dbid === cityDbid).code;

        this.axios.all([
          this.axios.get(this.districtURI, {
            params: {
              // 州市
              parentId: cityDbid,
              // 工信部门
              type: 'G_county',
              // 不是省工信的处室
              inheritParent: 'F',
              // 未禁用
              disabled: 'F'
            }
          }),
          this.axios.get(this.districtURI, {
            params: {
              // 州市
              accessCode: this.cityItems.find(v => v.dbid === cityDbid).accessCode,
              // 工信部门
              type: 'P_county, P_city',
              // 不是省工信的处室
              inheritParent: 'F',
              // 未禁用
              disabled: 'F'
            }
          })
        ]).then(
          this.axios.spread(function (rspCounty, rspPark) {
            vm.countyItems = rspCounty.data.items;
            vm.countyLoading = false;

            vm.parkItems = rspPark.data.items;
            vm.parkLoading = false;
          })
        )
      },

      onParkChange(parkId) {
        const park = this.parkItems.find(p => p.dbid === parkId);
        this.item.county = park.districtId;
      },

      onRegister() {
        if (this.$refs.registerForm.validate()) {
          const vm = this;
          vm.message = '';
          vm.loading = true;
          this.axios.post(this.registerURI, this.item)
            .then(
              rsp => {
                vm.loading = false;
                vm.message = "注册成功，正在转到登录页面…";
                vm.$router.push("/login");
              })
            .catch(err => {
              vm.loading = false;
            })
        }
      }
    }
  }
</script>

<style>
  main div.content--wrap {
    padding: 1rem;
  }

  .container.grid-list-xl .layout .flex {
    padding: 0 12px;
  }

  .main-nav-bar {
    border-bottom-color: rgba(0, 0, 0, 0.12);
    border-bottom-width: 2px;
    border-bottom-style: solid;
  }

</style>



// WEBPACK FOOTER //
// src/components/Register.vue